import z from 'zod';

export const editInventoryAmountEventSchema = z.object({
  amount: z.preprocess(
    (val) => {
      if (typeof val === 'string' && val.trim() !== '') {
        return Number(val);
      }
      if (typeof val === 'number') {
        return val;
      }
      return val;
    },
    z
      .number({
        required_error: 'Amount is required',
        invalid_type_error: 'Amount is required',
      })
      .min(0, 'Amount must be greater or equal to 0')
      .max(1000, 'Amount must be less than 1000')
  ),
});
